module.exports = __webpack_public_path__ + "img/icons.24ded6f8.svg";